export const ROUTERS = {
  ERROR: "/error",
  MAIN: "/",
  ONBOARDING: "/onboarding",
  HISTORY: "/history",
  EXCHANGE: "/exchange/:id",
  HISTORY_REFERRAL_PAYMENTS: "/history-referral-payments",
  HISTORY_WITHDRAWALS: "/history-withdrawals",
  PROFILE: "/profile",

  VERIFICATION: "/verification",
  PHONE_NUMBER: "/phone-number",
  PASSPORT: "/passport",
  REFERRAL: "/referral",
  SELFY: "/selfy",

  FAQ: "/faq",
  WITHDRAWAL: "/withdrawal",
};

export const getExchangeRoute = (id: string) => `/exchange/${id}`;
